import { StyledFontAwesomeIconMui5 } from 'components/atoms/FontAwesomeIcon';
import { styled } from '@mui/material/styles';

export const FieldLabelIconMui5 = styled(StyledFontAwesomeIconMui5)(
  ({ theme }) => `
  margin-right: ${theme.spacing(1)};`,
);
